var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0421 3.53791C10.0421 4.23764 9.83463 4.92166 9.44588 5.50346C9.05713 6.08527 8.50458 6.53873 7.85811 6.80651C7.21165 7.07428 6.50029 7.14434 5.81401 7.00783C5.12772 6.87132 4.49732 6.53437 4.00254 6.03958C3.50775 5.5448 3.1708 4.9144 3.03429 4.22812C2.89778 3.54183 2.96784 2.83048 3.23562 2.18401C3.50339 1.53754 3.95686 0.984995 4.53866 0.596245C5.12047 0.207495 5.80448 0 6.50422 0C6.96882 0 7.42888 0.0915107 7.85811 0.269307C8.28735 0.447104 8.67737 0.707704 9.00589 1.03623C9.33442 1.36475 9.59502 1.75477 9.77281 2.18401C9.95061 2.61325 10.0421 3.0733 10.0421 3.53791Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6921 8.13145C11.1199 7.55379 10.4373 7.09726 9.68494 6.78909C8.93256 6.48091 8.12583 6.32741 7.31285 6.33773H5.69108C4.85996 6.32631 4.03544 6.48657 3.26912 6.80849C2.5028 7.13041 1.81118 7.60705 1.23756 8.20857C0.460104 9.0136 0.0177101 10.084 0 11.2031L0 14.8563H13.0039V11.2031C12.9849 10.0465 12.5141 8.94322 11.6921 8.12932",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62646 13.05L8.75803 8.53418",
    stroke: "#888888",
    strokeWidth: 1.23824,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43359 8.85181L8.94938 12.9834",
    stroke: "#888888",
    strokeWidth: 1.23824,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspension);
export default __webpack_public_path__ + "static/media/suspension.e05d9642046aa74f4f1a9126a689364b.svg";
export { ForwardRef as ReactComponent };